import React from "react";

import TermListItem from "./TermListItem";
import NoResults from "../../../common/NoResults";
import { SonicTermData } from "../../../common/classes/SonicTerm";

import styles from "../../management/db-list/DBList.module.scss";

type ListProps = {
  terms?: Array<SonicTermData>;
  name_type: string;
  noColor?: boolean;
  handleName?: (val: string) => void;
  handleColor?: (val: string) => void;
  handleImage?: (val: File) => void;
  listItemSubmit: (
    item_id: string,
    name?: string,
    color?: string,
    img?: File
  ) => void;
};
const TermList: React.FC<ListProps> = ({
  terms,
  name_type,
  noColor,
  handleName,
  handleImage,
  handleColor,
  listItemSubmit,
}) => {
  if (!terms || terms.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={
          handleImage
            ? `${styles["f-dbList__category"]} ${styles["head"]} ${styles["term"]}`
            : `${styles["f-dbList__category"]} ${styles["head"]} ${styles["courses"]}`
        }
      >
        {handleName ? <div>{name_type}</div> : null}
        {handleImage ? <div>画像</div> : null}
        {handleColor ? <div>カラー</div> : null}
        <div>アクション</div>
      </div>
      {terms?.map((term, i) => (
        <TermListItem
          key={i}
          i={i}
          id={term.id}
          noColor={noColor}
          name={handleName ? term.name : undefined}
          color={handleColor ? term.color : undefined}
          img={
            handleImage && term.img?.thumbnail?.url !== undefined
              ? term.img.thumbnail.url
              : handleImage
              ? ""
              : undefined
          }
          handleSubmit={listItemSubmit}
        />
      ))}
    </div>
  );
};

export default TermList;
